/*
 * (c) Copyright, 2024, Medidata Solutions Worldwide, Inc. All rights reserved.
 */
import { useEffect, RefObject } from 'react'

function useNumericOnly(ref: RefObject<HTMLInputElement | null> | null, restrictCharNumberLength?: number): void {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const { keyCode, target } = event

      if (
        (keyCode >= 48 && keyCode <= 57) ||
        (keyCode >= 96 && keyCode <= 105) ||
        keyCode === 8 ||
        keyCode === 37 ||
        keyCode === 38 ||
        keyCode === 39 ||
        keyCode === 40
      ) {
        restrictCharNumberLength ? restrictCharNumber() : null
      } else {
        return event.preventDefault()
      }

      function restrictCharNumber() {
        if ((target as HTMLInputElement)?.value?.length >= (restrictCharNumberLength || 0)) {
          if (keyCode === 8 || keyCode === 16 || keyCode === 37 || keyCode === 39 || keyCode === 38 || keyCode === 40) {
            return true
          } else {
            return event.preventDefault()
          }
        } else {
          return true
        }
      }
    }

    if (ref?.current) {
      ref.current.addEventListener('keydown', handleKeyDown)
    }

    return () => {
      ref?.current?.removeEventListener('keydown', handleKeyDown)
    }
  }, [ref, restrictCharNumberLength])
}

export default useNumericOnly

/*
    KeyCode   |   Description
    - 8       |    Backspace
    - 16      |    Shift
    - 37      |    Left Arrow
    - 38      |    Up Arrow
    - 39      |    Right Arrow
    - 40      |    Down Arrow
    - 48-57   |    0-9
    - 96-105  |    0-9(Numeric keypad)
*/
